import api from "./api";

const portalService = {
  // ── Student / Parent ───────────────────────────────────────────────────────
  getProfile: () => api.get("/portal/profile").then((r) => r.data),
  getAttendance: (params) => api.get("/portal/attendance", { params }).then((r) => r.data),
  getSubjectAttendance: (params) => api.get("/portal/subject-attendance", { params }).then((r) => r.data),
  getResults: () => api.get("/portal/results").then((r) => r.data),
  getTimetable: (params) => api.get("/portal/timetable", { params }).then((r) => r.data),
  getExams: (params) => api.get("/portal/exams", { params }).then((r) => r.data),
  getFees: (params) => api.get("/portal/fees", { params }).then((r) => r.data),
  getCertificates: () => api.get("/portal/certificates").then((r) => r.data),
  getEvents: (params) => api.get("/portal/events", { params }).then((r) => r.data),

  // ── Student / Parent — Homework (new) ─────────────────────────────────────
  // studentId is never sent from the client — the backend derives it from
  // the logged-in user's linkedStudent for both student and parent roles.
  getHomework: (params) => api.get("/portal/homework", { params }).then((r) => r.data), // ?academicYear=
  submitHomework: (homeworkId, data) =>
    api.post(`/portal/homework/${homeworkId}/submit`, data).then((r) => r.data), // { submittedText, attachments }
  uploadHomeworkFile: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api
      .post("/portal/homework/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  // ── Teacher — existing ─────────────────────────────────────────────────────
  getTeacherProfile: () => api.get("/portal/teacher/profile").then((r) => r.data),
  getTeacherAttendance: (params) => api.get("/portal/teacher/attendance", { params }).then((r) => r.data),
  getTeacherPayslips: () => api.get("/portal/teacher/payslips").then((r) => r.data),

  // ── Teacher — subjects & results (existing) ────────────────────────────────
  getTeacherSubjects: () =>
    api.get("/portal/teacher/subjects").then((r) => r.data),

  getTeacherExams: (params) =>
    api.get("/portal/teacher/exams", { params }).then((r) => r.data),

  getTeacherResultSheet: (examId) =>
    api.get(`/portal/teacher/exams/${examId}/result-sheet`).then((r) => r.data),

  saveTeacherResults: (examId, entries) =>
    api.post(`/portal/teacher/exams/${examId}/results`, { entries }).then((r) => r.data),

  // ── Teacher — Homework (new) ────────────────────────────────────────────────
  // All auto-scoped server-side to the logged-in teacher's linkedEmployee —
  // no teacher id is ever passed from the client.
  getTeacherHomework: (params) =>
    api.get("/portal/teacher/homework", { params }).then((r) => r.data), // ?academicYear=

  getHomeworkSubmissions: (homeworkId) =>
    api.get(`/portal/teacher/homework/${homeworkId}/submissions`).then((r) => r.data),

  gradeHomeworkSubmission: (submissionId, data) =>
    api
      .put(`/portal/teacher/homework/submissions/${submissionId}/grade`, data)
      .then((r) => r.data), // { marksObtained, feedback }

  // ── Teacher — Subject Attendance (new) ──────────────────────────────────────
  // Unlike the other /portal/teacher/* calls above, these hit /subject-attendance
  // directly rather than a /portal/teacher/subject-attendance proxy — that's
  // where the actual backend logic lives. subjectId IS sent from the client
  // (a teacher can have several subjects), but access is still verified
  // server-side against the teacher's own Subject.teachers assignment
  // (req.user.linkedEmployee) — a teacher can never fetch or mark a subject
  // they aren't assigned to, even by guessing its id.
  getTeacherSubjectPeriods: (params) =>
    api.get("/subject-attendance/periods", { params }), // ?subjectId=&academicYear=&attendanceDate=

  getTeacherSubjectSheet: (params) =>
    api.get("/subject-attendance/sheet", { params }), // ?subjectId=&academicYear=&attendanceDate=&periodNo=

  markTeacherSubjectAttendance: (payload) =>
    api.post("/subject-attendance", payload), // { subjectId, academicYear, attendanceDate, periodNo, notes, records }

  getTeacherSubjectAttendanceReport: (params) =>
    api.get("/subject-attendance/report", { params }), // ?subjectId=&academicYear=&reportType=&fromDate=&toDate=&search=&studentId=

  // ── Teacher — Leave Management ──────────────────────────────────────────────
  getTeacherLeaveBalance: () => api.get("/portal/teacher/leave/balance"),
  getTeacherLeaveApplications: () => api.get("/portal/teacher/leave"),
  submitTeacherLeaveApplication: (data) => api.post("/portal/teacher/leave", data),

  // ── Teacher — Syllabus Tracking ─────────────────────────────────────────────
  getTeacherSyllabusList: (params) =>
    api.get("/portal/teacher/syllabus", { params }).then((r) => r.data),
  getTeacherSubjectSyllabus: (subjectId, params) =>
    api.get(`/portal/teacher/syllabus/${subjectId}`, { params }).then((r) => r.data),
  updateTeacherUnitProgress: (subjectId, unitNo, data) =>
    api.put(`/portal/teacher/syllabus/${subjectId}/unit/${unitNo}`, data).then((r) => r.data),
  updateTeacherSyllabusBulk: (subjectId, data) =>
    api.put(`/portal/teacher/syllabus/${subjectId}/bulk`, data).then((r) => r.data),
};


export default portalService;